export function getSortedMapByValue(map, compareFn) {
    if (map.size <= 1) {
        return map;
    }
    var entries = Array.from(map.entries());
    entries.sort(function (entry1, entry2) { return compareFn(entry1[1], entry2[1]); });
    return new Map(entries);
}
//# sourceMappingURL=getSortedMapByValue.js.map